import { useNavigate } from 'react-router-dom';
import useAuthContext from 'app/hooks/useAuthContext';
import useIsSSOUser from 'app/hooks/useIsSSOUser';
import useSignOut from 'app/hooks/useSignOut';
import { usePhoneVerificationStore } from 'app/store';
import { authenticatedPaths, unauthenticatedPaths } from 'app/constants/routes';

function useNavbarActions() {
  const { user, company, cognitoUser } = useAuthContext();
  const isSSOUser = useIsSSOUser(cognitoUser);
  const { mutate: signOut } = useSignOut();
  const navigate = useNavigate();
  const { isModalOpen, closeModal, hasBeenShown, openModal } = usePhoneVerificationStore();

  const handleLogout = () => {
    signOut();
    navigate(unauthenticatedPaths.authentication);
  };

  const handleProfileClick = () => {
    navigate(authenticatedPaths.profile.path);
  };

  const handleChangePasswordClick = () => {
    navigate(authenticatedPaths.changePassword.path);
  };

  return {
    closeModal,
    company,
    handleChangePasswordClick,
    handleLogout,
    handleProfileClick,
    hasBeenShown,
    isModalOpen,
    isSSOUser,
    openModal,
    user,
  };
}

export default useNavbarActions;
